export default __webpack_public_path__ + "static/media/headerImg.639c4fda.png";